import React, {useContext, useMemo} from "react";
import BoldTypography from "components/BoldTypography";
import Typography from "components/Typography";
import Tr from "translations/Translations";
import annualReportSteps from "../../constants/annualReportSteps";
import FormTranslationContext from "context/FormTranslationContext";
import Link from "components/Link";
import RouterPath from "libs/RouterPath";
import {useParams} from "react-router";

function AnnualReportError(
    {
        report
    }
) {
    const {formTr, dictTranslations} = useContext(FormTranslationContext);
    const params = useParams();

    const getMapKeys = (iterator) => {

        const keys = [];
        let next = iterator.next();
        while (!next.done) {
            keys.push(next.value);
            next = iterator.next();
        }
        return keys;
    }

    const getTranslatedErrorsView = (translatedErrors) => {
        const steps = Object.keys(translatedErrors);
        return <ul>
            {
                steps.map(step => <li key={step}>
                    <Link to={RouterPath.createPath(RouterPath.annualReport.MP_ANNUAL_REPORT_REPORT_ID_TABLE, {
                        id: params.id,
                        table: step
                    })}>{formTr("mmia." + step)}</Link>
                    <ul>
                        {
                            getMapKeys(translatedErrors[step].keys()).map((x, i) => <li key={i}>
                                {x}
                                <ul>
                                    {
                                        translatedErrors[step].get(x).map((e, j) => <li key={j}>{e}</li>)
                                    }
                                </ul>
                            </li>)
                        }
                    </ul>


                </li>)
            }
        </ul>

    }

    const getDescribedErrors = () => {
        const described = {};
        Object.keys(report.errorsDescribed).forEach(wholeKey => {
            const split = wholeKey.split(".");
            if (!described.hasOwnProperty(split[0])) {
                described[split[0]] = new Map();
            }

            switch (split[0]) {
                case annualReportSteps.purchaser: {
                    const subKey = split[1];
                    const errors = described[split[0]].get(subKey) || [];
                    errors.push(report.errorsDescribed[wholeKey]);
                    described[split[0]].set(subKey, errors)
                    break;
                }
                case annualReportSteps.belowEu: {
                    const subKey = (dictTranslations.procedures[split[1]] || Tr("annual_report_default_error")) + " " + (dictTranslations.orderType[split[2]] || "");
                    const errors = described[split[0]].get(subKey) || [];
                    errors.push(report.errorsDescribed[wholeKey]);
                    described[split[0]].set(subKey, errors)
                    break;
                }
                case annualReportSteps.aboveEu:
                case annualReportSteps.conflict:
                case annualReportSteps.community:
                case annualReportSteps.social:
                case annualReportSteps.innovative: {
                    const subKey = (dictTranslations.type[split[1]] || Tr("annual_report_default_error"));
                    const errors = described[split[0]].get(subKey) || [];
                    errors.push(report.errorsDescribed[wholeKey]);
                    described[split[0]].set(subKey, errors)
                    break;
                }
                case annualReportSteps.exception: {
                    const subKey = (dictTranslations.exceptions[split[1]] || Tr("annual_report_default_error"));
                    const errors = described[split[0]].get(subKey) || [];
                    errors.push(report.errorsDescribed[wholeKey]);
                    described[split[0]].set(subKey, errors)
                    break;
                }
                case annualReportSteps.notIncluded: {
                    const subKey = (dictTranslations.notIncluded[split[1]] || Tr("annual_report_default_error"));
                    const errors = described[split[0]].get(subKey) || [];
                    errors.push(report.errorsDescribed[wholeKey]);
                    described[split[0]].set(subKey, errors)
                    break;
                }
                default: {

                }
            }
        })
        return described;
    }

    const getErrors = () => {
        let translatedErrors = null;
        if (report.errorsDescribed) {
            try {
                translatedErrors = getDescribedErrors();
            } catch (e) {
                console.error(e);
            }
        }
        return <>
            <BoldTypography>{Tr("annual_report_ezamowienia_error")}</BoldTypography>
            {!!translatedErrors ? getTranslatedErrorsView(translatedErrors) :
                <Typography>{report.error}</Typography>}
        </>
    }

    const errors = useMemo(() => {
        if (!report.error && !report.errorsDescribed) {
            return null;
        }
        return getErrors();
        // eslint-disable-next-line
    }, [report.error, report.errorsDescribed]);

    return errors;

}


export default AnnualReportError;